export enum MessageType {
  TEXT = 'text',
  PUBLISH_DOCUMENT = 'publish-document',
  REQUEST_DOCUMENT = 'request-document',
  REQUEST_ESIGNATURE = 'request-esignature',
}

export const COMBO_BOX_MAPPER = {
  'request-information': {
    label: 'Request Information',
    messageType: MessageType.TEXT,
  },
  'request-multi-document': {
    label: 'Request Documents',
    messageType: MessageType.REQUEST_DOCUMENT,
  },
  'request-esignature': {
    label: 'Request eSignature',
    messageType: MessageType.REQUEST_ESIGNATURE,
  },
}

export const CUSTOMER_MESSAGES_TEMPLATES = {
  HOI: `Hello and good morning / afternoon,

We require an updated insurance declaration page(s) with our mortgagee clause added in 1st / 2nd 3rd lien position.

Per your Insurance provider – <strong><em>XXXXX Insurance</em></strong> - you will need to contact your agent to make the needed changes.

The Unlock mortgagee clause should read:

<strong>Unlock Partnership Solutions Inc.

ISAOA

5 Bryant Park, 23rd Floor

New York, NY 10018

<em>Transaction ID</em> XXXXXXX</strong>

 Thank you. Your prompt attention is greatly appreciated as to not delay your funding.`,
  LOE: `
Thank you for submitting your application for an Unlock Agreement. Because you have had your credit pulled with mortgage lenders within the last 90 days, we will need you to provide us with some additional information:

Creditor Name:
Date of Inquiry:
Reason the Inquiry was pulled:

Indicate whether this inquiry resulted in an account being opened or will be opened:

When we get closer to finalizing your terms for your Unlock Agreement, we may need confirmation from the lender that you no longer have an active application. We will reach out to you if and when we need this documentation. If you have any questions, please don't hesitate to contact me at your earliest convenience. Thank you, and have a great day!
  `,
  APPRAISAL: (applicantName, username, userPhone, dealTeamUser) => `
Hello ${applicantName}

My name is ${username}, and I am your Transaction Specialist working with your HEO ${dealTeamUser}.

Your title came back with no items needing to be addressed.

I have ordered your appraisal.

Unlock uses an independent third-party to conduct appraisals. You should receive a call soon from that company to schedule your appraisal inspection. Let me know if you do not hear from someone within the next 5 business days.

Depending on the availability of appraisers, the time to complete the report may vary. You can expect the process to take anywhere from 7 to 10 days.

I will reach out if there any issues with your appraisal.

Please let us know if you have any questions.

Thank you,

${username}

Transaction Specialist | Unlock Technologies

${userPhone}`,
}

export const CUSTOMER_MESSAGES_TEMPLATES_MAPPER = (
  applicantName,
  username,
  userPhone,
  dealTeamUser
) => [
  { label: 'HOI - Client Assist Updating HOI', value: CUSTOMER_MESSAGES_TEMPLATES.HOI },
  {
    label: 'LOE - Mortgage and Banking/Finance Inquiries within 90 days',
    value: CUSTOMER_MESSAGES_TEMPLATES.LOE,
  },
  {
    label: 'Ordering Appraisal  - Clean Title',
    value: CUSTOMER_MESSAGES_TEMPLATES.APPRAISAL(applicantName, username, userPhone, dealTeamUser),
  },
]
